<template>
    <div class="work_point_collapse-container" :class="{open : isOpen, close: !isOpen}"
         :style="{ maxHeight: elementsContainerHeight + 'px'}">

        <div @click="toggleOpen" class="title-container" ref="title_container">
            <h2 class="title">{{translate(getWorkPointParameters.title)}}</h2>
            <div class="plus_icon"></div>
        </div>
        <ul class="elements-container" ref="elements_container">
            <li v-for="(element, key) in getWorkPointParameters.elements" v-if="element.active && shouldDisplay(key)"
                class="element">
                <div class="title tooltip">
                    <span>{{translate(key)}}</span>
                </div>
                <span class="unit" v-html="getUnit(key)"/>
                <span class="value expand-value">{{printCountOfFans(element) + printValue(key, element)}}</span>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "WorkPointCollapse",
        data() {
            return {
                validatorLock: false,
                isOpen: true,
                elementsContainerHeight: 0,
                defaultMaxHeight: 43
            }
        },
        methods: {
            shouldDisplay(key) {
                switch (key) {
                    case "electrical_power_with_material":
                        if (this.getWorkPointParameters.elements['material_amount'].value > 0)
                            return true;
                        else
                            return false;

                        break;
                    case "amperage_v2":
                        let voltages = this.getActiveFunVoltages();

                        if (voltages && voltages.length > 1)
                            return true;

                        return false;
                        break;
                    default:
                        return true;
                        break;
                }

                return true;
            },
            printCountOfFans(element){
                if (!element || !element.displayCountOfFans || this.countSimilarFans == 0 || !this.$store.state.activeFun || !this.$store.state.activeFun.data || !this.$store.state.activeFun.data.number_of_fans || this.$store.state.activeFun.data.number_of_fans < 2)
                    return "";
                else
                    return this.$store.state.activeFun.data.number_of_fans + " x ";
            },
            printValue(key, element) {
                let value = element.value;
                if (element.hasOwnProperty("paramsTableId") && element['paramsTableId'] != "" && this.$store.state.activeFun) {
                    if (this.$store.state.activeFun.params && this.$store.state.activeFun.params[element['paramsTableId']]) {
                        value = this.$store.state.activeFun.params[element['paramsTableId']];
                    } else {
                        if (element['paramsTableId'] == "fan_type")
                            value = this.$store.state.activeFun.type;
                        else if (element['paramsTableId'] == "fan_type_number")
                            value = this.$store.state.activeFun.model;
                    }

                    element.value = value;
                }

                if (element.hasOwnProperty("requestedValue") && element['requestedValue'] != "" && this.$store.state.fourthStepParametersSelected[element.requestedValue])
                    value = this.$store.state.fourthStepParametersSelected[element.requestedValue].value;

                if (element.hasOwnProperty("calculated") && element.calculated === true) {
                    let selectedFanData = this.$store.state.activeFun.selectedFanData;
                    value = 0;

                    switch (key) {
                        case "weight":
                            if (selectedFanData)
                                value = parseFloat(selectedFanData.mass) + parseFloat(this.$store.state.activeFun.engine.weight)
                            break;
                        case "pipeline_average_speed":
                            value = parseFloat(this.getWorkPointParameters.elements['performance'].value / (Math.PI * Math.pow((this.$store.state.fourthStepParametersSelected["pipeline_diameter"].value / 2), 2))).format(2);
                            value = value.replace(',', '.');
                            break;
                        case "average_rated_speed_of_the_fan":
                            if (this.$store.state.activeFun && this.$store.state.activeFun.data)
                                value = parseFloat((this.getWorkPointParameters.elements["work_frequency"].value / 50) * this.$store.state.activeFun.data.avg_nominal_speed).toFixed(0);
                            break;
                        case "minimum_amount_of_air_at_the_minimum_frequency":
                            var minimum_frequency_on_the_inverter1 = 0;

                            if (this.$store.state.activeFun && this.$store.state.activeFun.data && this.$store.state.activeFun.selectedFanData) {
                                if(this.$fanObjParamsManager.GetSelectedElementOfOption(this.$store.state.fourthStepParametersSelected.number_of_fans_on_the_inverter.options[0].elements) == "0"){
                                    minimum_frequency_on_the_inverter1 = this.$fanObjParamsManager.GetSelectedElementOfOption(this.$store.state.fourthStepParametersSelected.network_frequency.options[0].elements);
                                }else {
                                    minimum_frequency_on_the_inverter1 = Math.sqrt((this.getWorkPointParameters.elements[this.getPressureType() + '_pressure'].value / this.getWorkPointParameters.elements["maximum_" + this.getPressureType() + '_pressure'].value) * Math.pow(this.$store.state.activeFun.data.network_frequency, 2));
                                }

                                if (minimum_frequency_on_the_inverter1 < this.$store.state.activeFun.selectedFanData.min_frequency)
                                    minimum_frequency_on_the_inverter1 = this.$store.state.activeFun.selectedFanData.min_frequency;

                                value = (minimum_frequency_on_the_inverter1 / this.getWorkPointParameters.elements['work_frequency'].value) * this.getWorkPointParameters.elements['minimum_air_amount'].value;
                            }

                            break;
                        case "maximum_rotor_speed":
                            if (selectedFanData)
                                value = parseFloat(selectedFanData.max_speed);
                            break;

                        case "casing_dimensions":
                            if (selectedFanData)
                                value = selectedFanData.external_dimensions;
                            break;

                        case "electrical_power":
                            // if (this.$store.state.activeFun && this.$store.state.activeFun.engine && this.$store.state.activeFun.engine.efficiency_3_4)
                            //     value = (this.getWorkPointParameters.elements['power_on_shaft'].value / parseFloat(this.$store.state.activeFun.engine.efficiency_3_4));
                            // break;

                            if (this.$store.state.activeFun && this.$store.state.activeFun.engine && this.$store.state.activeFun.engine.efficiency_3_4)
                                value = (this.getWorkPointParameters.elements['power_on_shaft_with_material'].value / parseFloat(this.$store.state.activeFun.engine.efficiency_3_4));
                            break;

                        case "electrical_power_with_material":
                            if (this.$store.state.activeFun && this.$store.state.activeFun.engine && this.$store.state.activeFun.engine.efficiency_3_4)
                                value = (this.getWorkPointParameters.elements['power_on_shaft_with_material'].value / parseFloat(this.$store.state.activeFun.engine.efficiency_3_4));
                            break;

                        case "amperage_v1":
                            var voltages = this.getActiveFunVoltages();
                            var calculated = 0;

                            if (voltages && this.$store.state.activeFun && this.$store.state.activeFun.engine) {
                                if (voltages.length > 0)
                                    calculated = 1000 * (this.getWorkPointParameters.elements['power_on_shaft_with_material'].value / (voltages[0] * Math.sqrt(3) * this.$store.state.activeFun.engine.power_factor * this.$store.state.activeFun.engine.efficiency_3_4));
                            }

                            value = calculated;
                            break;
                        case "amperage_v2":
                            var voltages = this.getActiveFunVoltages();
                            var calculated = 0;

                            if (voltages && this.$store.state.activeFun && this.$store.state.activeFun.engine) {
                                if (voltages.length > 1)
                                    calculated = 1000 * (this.getWorkPointParameters.elements['power_on_shaft_with_material'].value / (voltages[1] * Math.sqrt(3) * this.$store.state.activeFun.engine.power_factor * this.$store.state.activeFun.engine.efficiency_3_4));
                            }

                            value = calculated;
                            break;
                        case "characteristic_coefficient":
                            if (this.$store.state.activeFun && this.$store.state.activeFun.data && this.$store.state.activeFun.data.characteristic_coefficient)
                                value = parseFloat(this.$store.state.activeFun.data.characteristic_coefficient).toFixed(3);
                            break;
                        case "average_length_of_the_shredded_material":
                            if (this.$store.state.activeFun && this.$store.state.activeFun.data) {
                                var number_of_fans = (this.$store && this.$store.state && this.$store.state.activeFun && this.$store.state.activeFun.data && this.$store.state.activeFun.data['number_of_fans']) ? this.$store.state.activeFun.data['number_of_fans'] :  1;
                                var v_wlot = this.getWorkPointParameters.elements['performance'].value / (Math.PI * 0.25 * Math.pow((0.001 * this.$store.state.activeFun.data.avg_inlet), 2));
                                var average_rated_speed_of_the_fan = (this.getWorkPointParameters.elements["work_frequency"].value / 50) * this.$store.state.activeFun.data.avg_nominal_speed;

                                var l_sr = (v_wlot / ((this.getWorkPointParameters.elements['work_frequency'].value / 50) * average_rated_speed_of_the_fan / 60 * this.$store.state.activeFun.data.blades_amount)) / number_of_fans;

                                value = l_sr;
                            }
                            break;
                        case "minimum_frequency_on_the_inverter":
                            if (this.$store.state.activeFun && this.$store.state.activeFun.data && this.$store.state.activeFun.selectedFanData) {
                                if(this.$fanObjParamsManager.GetSelectedElementOfOption( this.$store.state.fourthStepParametersSelected.number_of_fans_on_the_inverter.options[0].elements) == "0"){
                                    value = this.$fanObjParamsManager.GetSelectedElementOfOption(this.$store.state.fourthStepParametersSelected.network_frequency.options[0].elements);
                                }else {
                                    value = Math.sqrt((this.getWorkPointParameters.elements[this.getPressureType() + '_pressure'].value / this.getWorkPointParameters.elements["maximum_" + this.getPressureType() + '_pressure'].value) * Math.pow(this.$fanObjParamsManager.getNetwork_frequency(this.$store), 2))

                                    if (value < this.$store.state.activeFun.selectedFanData.min_frequency)
                                        value = this.$store.state.activeFun.selectedFanData.min_frequency;
                                }
                            }
                            break;
                        case "drive":
                            if(this.$store.state.activeFun && this.$store.state.activeFun.selectedFanData) {
                                value = this.translate("drive_"+this.$store.state.activeFun.selectedFanData.drive);
                            }
                            break;
                        case "fan_temperature_increase":
                            if(this.$store.state.activeFun && this.$store.state.activeFun.selectedFanData) {
                                value = (this.getWorkPointParameters.elements['total_pressure'].value / (this.getWorkPointParameters.elements['air_density'].value * 1000 * this.getWorkPointParameters.elements['total_efficiency'].value)) + 273.15;
                            }
                            break;
                        default:
                            break;
                    }
                }
                // value = Number(value).format()

                if (this.countSimilarFans == 0)
                    return "-";
                else
                    return this.calcUnit(key, value);
            },
            manageSelectedFan() {
                this.$store.commit({
                    type: 'manageSelectedFan',
                });
            },
            getPressureType() {
                if (this.$store.state.fourthStepParametersSelected.pressure.options[0].elements[0].active == true) {
                    return this.$store.state.fourthStepParametersSelected.pressure.options[0].elements[0].value;
                } else {
                    return this.$store.state.fourthStepParametersSelected.pressure.options[0].elements[1].value;
                }
            },
            getActiveFunVoltages() {
                if (this.$store.state.activeFun && this.$store.state.activeFun.data && this.$store.state.activeFun.data.network_frequency && this.$store.state.activeFun.engine) {
                    let frequency = this.$fanObjParamsManager.GetSelectedElementOfOption(this.$store.state.fourthStepParametersSelected.network_frequency.options[0].elements);

                    let voltage = this.$store.state.activeFun.engine['voltage_' + frequency + '_hz'];

                    if (voltage) {
                        let voltages = voltage.split("/");

                        return voltages;
                    }
                }

                return [];
            },
            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;

            },
            calcUnit(key, value) {
                if (value == "nieobliczalne" || value == "+nieskończoność" || value == "-nieskończoność")
                    return "-";

                if (!this.$store.state.ValueUnitMap[key] || !this.$store.state.ValueUnitMap[key].value != "" || !this.$store.state.ValueUnitMap[key].selected)
                    return value;

                this.$store.state.ValueUnitMap[key].selected.active = true;

                let param = {value: value};
                let option = {elements: {1: this.$store.state.ValueUnitMap[key].selected}};

                let arg = {
                    type: 'calcUnit',
                    param: param,
                    option: option,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;

            },
            getUnit(key) {

                if (key == "pipeline_average_speed")
                    return "[m/s]:&nbsp;"

                if (key == "price")
                    return "[EUR]:&nbsp;";

                if (key == 'casing_dimensions')
                    return "[mm]:&nbsp;"

                if (key == 'maximum_rotor_speed')
                    return "[1/min]:&nbsp;"

                if (key == 'average_rated_speed_of_the_fan')
                    return "[1/min]:&nbsp;"

                if (key == "characteristic_coefficient")
                    return "[-]:&nbsp;";

                if (key == "casing_dimensions")
                    return "[mm]:&nbsp;";

                if (key == "drive")
                    return "[-]:&nbsp;";

                if (key == "fan_temperature_increase")
                    return "[°C]:&nbsp;";

                if (this.$store.state.ValueUnitMap[key] && this.$store.state.ValueUnitMap[key].value != "" && this.$store.state.ValueUnitMap[key].selected && this.$store.state.ValueUnitMap[key].selected.value)
                    return "[" + this.$store.state.ValueUnitMap[key].selected.value + "]:&nbsp;";
                else
                    return ":&nbsp;";
            },
            addListener() {
                let _this = this;
                window.addEventListener('resize', _this.setMaxHeight)
            },

            removeListener() {
                let _this = this;
                window.removeEventListener('resize', _this.setMaxHeight);
            },

            toggleOpen() {
                this.isOpen = !this.isOpen
                this.setMaxHeight();
            },

            setMaxHeight() {
                if (this.isOpen && this.$refs.elements_container && this.$refs.elements_container.clientHeight && this.$refs.title_container && this.$refs.title_container.clientHeight) {
                    this.elementsContainerHeight = this.$refs.elements_container.clientHeight + this.$refs.title_container.clientHeight + this.defaultMaxHeight;
                } else {
                    this.elementsContainerHeight = this.defaultMaxHeight;
                }
            }
        }
        ,
        computed: {

            getWorkPointParameters() {
                return this.$store.state.workPointParameters;
            },

            countSimilarFans() {
                this.manageSelectedFan();

                if (this.$store.state.fansTableData.FanTableRef)
                    return this.$store.state.fansTableData.FanTableRef.allFilteredData.length;
                else
                    return 0;
            },
        },

        mounted() {
            this.addListener();
            this.setMaxHeight();
        }
    }
</script>
